// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1386":"04f8ad76","5494":"04f8ad76","6046":"45748042"}[chunkId] + ".chunk.css";
};